import React, { useEffect } from "react";
import { useLoaderData, useLocation } from "react-router";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "#/components/Breadcrumb";
import { Link } from "#/components/Link";
import { withPaywall } from "#/components/WithPaywall";
import { formatDate } from "#/lib/formatDate";
import { UserPagePath } from "#/lib/pagesHelper";
import { canViewNewsArticle } from "#/lib/permissions";
import { serializeQuery } from "#/lib/serializeQuery";

type Article = {
  id: number;
  category: string;
  title: string;
  published_at: string;
  content: string;
};

type LoaderData = {
  data: Article[];
};

function findAttribute(accessorKey, data) {
  return data.find((item) => item.accessorKey === accessorKey)?.value || "";
}

function buildNewsArticleCategoryURL(category: string) {
  const categorySlugMap = {
    "Notícias Tributárias": "tax_news",
    Artigos: "articles_and_other_content",
    "Atualizações de Teses": "system_updates",
    "Dica da Click": "weekly_tip",
  };

  const categoryFilter = {
    columnFilters: {
      category: categorySlugMap[category],
    },
  };
  return `/news_articles/latest?${serializeQuery(categoryFilter)}`;
}

function NewsArticleDetails() {
  const { data } = useLoaderData() as LoaderData;

  const title = findAttribute("title", data);
  const published_at = findAttribute("published_at", data);
  const content = findAttribute("content", data);
  const category = findAttribute("category", data);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-muted dark:bg-background p-8">
      <div className="max-w-4xl mx-auto bg-background p-6 rounded-lg shadow dark:border-2">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={UserPagePath.NEWS_ARTICLES}>
                Monitoramento Tributário
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink href={UserPagePath.NEWS_ARTICLES_LATEST}>
                Últimos conteúdos
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>
                <BreadcrumbLink href={buildNewsArticleCategoryURL(category)}>
                  <h2 className="text-primary">{category}</h2>
                </BreadcrumbLink>
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <h1 className="text-3xl font-bold mt-6 mb-2 font-title">{title}</h1>
        <div className="text-base mb-8 text-muted-foreground">
          {formatDate(published_at)}
        </div>
        <div
          className="text-lg text-foreground"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
}

export default withPaywall(NewsArticleDetails, canViewNewsArticle);
